import React from 'react';
import { useI18n } from '../../hooks/useI18n';
import { classNames } from '../../utils/classNames';

export const SITE_LOGO_SRC = `${process.env.PUBLIC_URL || ''}/logo128.png`;

const SIZE_STYLES = {
  sm: { box: 'h-10 w-10 rounded-2xl', img: 'h-7 w-7' },
  md: { box: 'h-11 w-11 rounded-xl', img: 'h-8 w-8' }
};

export const SiteLogo = ({ size = 'sm', className, imgClassName }) => {
  const { t } = useI18n();
  const styles = SIZE_STYLES[size] || SIZE_STYLES.sm;

  return (
    <div
      className={classNames(
        'flex shrink-0 items-center justify-center overflow-hidden border border-border bg-logo-box shadow-sm',
        styles.box,
        className
      )}
    >
      <img
        src={SITE_LOGO_SRC}
        alt={t('appName')}
        className={classNames('object-contain', styles.img, imgClassName)}
        width={128}
        height={128}
        decoding="async"
      />
    </div>
  );
};
